module.exports = __webpack_public_path__ + "img/kolor-19.559fa28d.png";